import * as ObjectExtensions from "../../../utils/CoreExtensions/ObjectExtensions";

const upcomingMeetingWidgetReducers = {
  setUpcomingMeetingWidget: (state, action) => {
    state.upcomingMeetingWidget = action.payload;
  },
  updateUpcomingMeetingWidget: (state, action) => {
    state.upcomingMeetingWidget = ObjectExtensions.deepMerge(state.upcomingMeetingWidget, action.payload);
  },
  reloadUpcomingMeetingWidget: (state, action) => {
    state.upcomingMeetingWidget.reloadWidget = action.payload;
  },
  showLoaderForUpcomingMeetingWidget: (state, action) => {
    state.upcomingMeetingWidget.showLoader = action.payload;
  }
}

export default upcomingMeetingWidgetReducers;